export default "__VITE_ASSET__KjSzLj15__"